import { Component, OnInit, Output, EventEmitter, ViewChild, OnChanges, DoCheck, OnDestroy } from '@angular/core';
import { FormControl, Validators, FormGroup } from '@angular/forms';
import { Router } from '@angular/router';
import { MatStepper } from '@angular/material/stepper';
import { BasicDetailsComponent } from './components/basic-details/basic-details.component';
import { SelectItem } from 'primeng/api';
import { ContactsComponent } from './components/contacts/contacts.component';
import { FolderStructureComponent } from './components/folder-structure/folder-structure.component';
import { AddEngagement } from '../entities/add-engagement';
import { ConfirmationService } from 'primeng/api';
import { EngagementManagementService } from '../../framework/services/engagement-mgmt.service';
import { LanguageService } from '../../framework/services/language.service';
import { AddEngagementMemoryService } from './add-engagement-memory-service/add-engagement-memory.service';
import { CommonService } from '../../framework/services/common.service';
import { JurisdictionService } from '../../framework/services/jurisdiction.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { CategoryConstant } from '../shared/app-constants/category-constants';
import { Console } from 'console';


@Component({
  selector: 'app-add-engagement',
  templateUrl: './add-engagement.component.html',
  styleUrls: ['./add-engagement.component.css']
})
export class AddEngagementComponent implements OnInit, DoCheck, OnDestroy {
  showLanguageSelection: boolean = true;
  selectedLanguageId: number = 0;
  defaultEnglishJson: any =""; //assigned empty
  islabelLoaded: boolean = false;
  alreadySelectedLanguageId = 0;
  selectedAppLanguageJson: any="";//assigned empty
  engagementSteps: { [key: string]: number } = {
    languageSelectionStep: 0,
    basicDetailsStep: 1,
    contactsStep: 2,
    folderStep: 3,
  };
  @ViewChild('stepper') stepper: MatStepper;
  showEngagementSection: ShowEngagementSection;

  isApplicationLanguageIdSet: boolean = false;

  constructor(private engagementManagementService: EngagementManagementService,
    private commonService: CommonService,
    private jurisductionService: JurisdictionService,
    private router: Router,
    private confirmationService: ConfirmationService,
    private languageSerivce: LanguageService,
    private engagementMemoryService: AddEngagementMemoryService,
    private spinner: NgxSpinnerService) {
    this.engagementMemoryService.resetEngagementMemory();
    this.showEngagementSection = new ShowEngagementSection(false, false, false, false);
    this.getLanguages();
  }
  ngOnInit() {
    this.spinner.show();
    this.loadLanguageLabel();
  }
  getLanguages() {
    this.languageSerivce.getLanguages().subscribe((response) => {
      if (response.responseStatus == 1) {

      } else {
        if (response != null && response.data.length > 0) {
          this.engagementMemoryService.setLanguages(response.data);
          this.getJurisdiction(this.selectedLanguageId);
        }
      }
    })
  }
  getJurisdiction(languageId: number) {
    this.jurisductionService.getJurisdictionDropDown(languageId).subscribe((response) => {
      if (response.responseStatus == 1) {

      } else {
        if (response != null && response.data.length > 0) {
          this.engagementMemoryService.setJurisdictionOption(response.data);
          this.getEngagementRoles(this.selectedLanguageId);
        }
      }
    })
  }
  getEngagementRoles(languageId: number) {
    this.commonService.getEngagementRoles(languageId).subscribe((response) => {
      if (response.responseStatus == 1) {

      } else {
        if (response != null && response.data.length > 0) {
          this.engagementMemoryService.setEngagementRoles(response.data);
          this.showEngagementSection = new ShowEngagementSection(true, false, false, false);
          this.spinner.hide();
        }
      }
    })
  }




  loadLanguageLabel() {
    let englishLanguageMappings, selectedLanguageMappings: any;
    return new Promise((resolve, reject) => {
      this.spinner.show();
      if (sessionStorage.getItem('selectedLanguageId')) {
        this.selectedLanguageId = 1;//JSON.parse(sessionStorage.getItem('selectedLanguageId'));
      }
      this.languageSerivce.currentData.subscribe(data => {
        if (this.alreadySelectedLanguageId != 0) {
          if (this.alreadySelectedLanguageId != data.Id && this.router.url == "/engagement-mgt") {
            this.router.navigate(["/home"], { queryParams: { engagementType: 'active' } })
          }
        }
        this.selectedLanguageId = data.Id
        this.alreadySelectedLanguageId = data.Id;
      });
      this.languageSerivce.mySubject.subscribe((data) => {
        var languageMappings = data;
        this.islabelLoaded = false;
        if (languageMappings?.length > 0) {
          englishLanguageMappings = languageMappings.filter(item =>
            item?.categoryName?.toLowerCase() === CategoryConstant.AddEngagement.toLowerCase()
            && Number(item?.languageId) === 1)[0];
          if (englishLanguageMappings?.isGlobal) {
            selectedLanguageMappings = languageMappings.filter(item =>
              item?.categoryName?.toLowerCase() === CategoryConstant.AddEngagement.toLowerCase()
              && Number(item?.languageId) === Number(this.selectedLanguageId))[0];
          }
          else {
            if (Number(this.selectedLanguageId) === 2) {
              selectedLanguageMappings = languageMappings.filter(item =>
                item?.categoryName?.toLowerCase() === CategoryConstant.AddEngagement.toLowerCase()
                && Number(item?.languageId) === Number(this.selectedLanguageId))[0];
            }
            else {
              selectedLanguageMappings = englishLanguageMappings;
            }
          }
          this.selectedAppLanguageJson = JSON.parse(selectedLanguageMappings.languageMappingJSON);
          this.defaultEnglishJson = JSON.parse(englishLanguageMappings.languageMappingJSON);
          this.getLanguages();
          this.islabelLoaded = true;
          resolve(1);
        }
        else {

        }
      });
    })
      .catch(err => {
        this.spinner.hide();
        console.log(err);
      });
  }


  labelReplacer(labelKey): string {
    return this.selectedAppLanguageJson[labelKey]?.trim() ? this.selectedAppLanguageJson[labelKey] ?? 'text not found' : this.defaultEnglishJson[labelKey] ?? 'text not found';
  }



  showNextControl(event) {
    if (event == "language")
      this.showEngagementSection = new ShowEngagementSection(true, false, false, false)
    if (event == "basicDetails")
      this.showEngagementSection = new ShowEngagementSection(false, true, false, false);
    if (event == "contacts")
      this.showEngagementSection = new ShowEngagementSection(false, false, true, false);
    if (event == "folderSelection")
      this.showEngagementSection = new ShowEngagementSection(false, false, false, true);
    this.stepper.next();
  }

  showPreviousControl(event) {
    if (event == "language")
      this.showEngagementSection = new ShowEngagementSection(true, false, false, false)
    if (event == "basicDetails")
      this.showEngagementSection = new ShowEngagementSection(false, true, false, false);
    if (event == "contacts")
      this.showEngagementSection = new ShowEngagementSection(false, false, true, false);
    this.stepper.previous();
  }

  ngDoCheck() {
    // if (this.selectedLanguageId != this.engagementMemoryService.getApplicationLanguageId() && this.isApplicationLanguageIdSet) {

    //   this.router.navigate(["/home"], { queryParams: { engagementType: 'active' } });
    // }
  }

  ngOnDestroy() {
  }
}

export class ShowEngagementSection {
  showLanguageSelection: boolean;
  showEngagementDetails: boolean;
  showContact: boolean;
  showFolderManagement: boolean;
  constructor(showLanguageSelection, showEngagementDetails, showContact, showFolderManagement) {
    this.showLanguageSelection = showLanguageSelection;
    this.showEngagementDetails = showEngagementDetails;
    this.showContact = showContact;
    this.showFolderManagement = showFolderManagement;
  }
}
